import {
  ApiFormWrapper,
  FormCheckbox,
  FormError,
  FormInput,
  FormPasswordField,
  FormSubmitButton,
} from "@/form"
import { useRegisterMutation } from "@/auth"

export default function Register() {
  const [register] = useRegisterMutation()

  return (
    <div>
      <ApiFormWrapper
        defaultValues={{
          email: "",
          password: "",
          terms: false,
        }}
        action={register}
        resetOnSuccess
      >
        <FormInput
          type="email"
          name="email"
          placeholder="Email"
          required
          className="mb-4 w-full"
        />
        <FormPasswordField
          name="password"
          placeholder="Password"
          isNewPassword
          className="mb-4 w-full"
        />
        <FormCheckbox
          name="terms"
          label="I agree to the Terms of Service and acknowledge the Privacy Policy"
          className="mb-4 w-full"
        />
        <FormError />
        <FormSubmitButton className="w-full">Sign up</FormSubmitButton>
      </ApiFormWrapper>
    </div>
  )
}
